import {Vehicle} from "@commons/models/domain/Vehicle";

export class VehicleLocationProcessor {
  setVehiclesLocation(updatedData: any, vehicle: Vehicle) {
    // wyszukanie w kontrolkach tych wlasciwych
    vehicle.ControlIndicators = vehicle.ControlIndicators || [];
    const geoIndicator = vehicle.ControlIndicators.find((i: any) => {
      return i.Tp == 8;
    });

    const lat = parseFloat((updatedData.Data.Lt || '').replace(',', '.'));
    const lon = parseFloat((updatedData.Data.Ln || '').replace(',', '.'));

    // ostatni czas z lokalizacji - nie wiem dlaczego - MCW-296
    if (updatedData.Data.LT) {
      vehicle.LastUpdated = updatedData.Data.LT;
      vehicle.LastUpdatedFrom = 'WS_DATA_2_GEO';
    }
    if (geoIndicator) {
      // aktualizacja parametrow
      geoIndicator.LV.T = updatedData.Data.LT;
      geoIndicator.LV.V = {Lat: lat, Lon: lon};
    }

    const location = vehicle.LL;

    if (location) {
      // DegeoInfo
      vehicle.LL = updatedData.Data;
    }
  }
}
